import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Catalog, Product } from "../../models/product.model";
import * as _ from "lodash";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment.prod";
import { CatalogService } from "../../services/catalog.service";
import { Hotkeys } from "../../@core/utils/hotkeys.service";
import { DOUBLE_PATTERN } from "../../@auth/components/constants";
import { DialogProductComponent } from "../dialog-product/dialog-product.component";
import Shop from "../../models/shop.model";
import { DialogProductInventoriesComponent } from "../dialog-product-inventories/dialog-product-inventories.component";
import { Receipt, ReceiptDetail } from "../../models/receipt.model";

@Component({
  selector: "ngx-view-receipt-products",
  styleUrls: ["./view-receipt-products.component.scss"],
  templateUrl: "./view-receipt-products.component.html",
})
export class ViewReceiptProductsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() uid = "";
  @Input() user: User;
  @Input() shopId = "";
  @Input() shop: Shop = new Shop();
  @Input() receiptId: string = "";
  @Input() receipt: Receipt = new Receipt();
  @Input() modeLayout?: string = "receipt";
  @Output() onSelectedProduct: EventEmitter<any> = new EventEmitter();
  @Output() onNewProduct: EventEmitter<any> = new EventEmitter();
  @Output() onSummaryReceipt: EventEmitter<any> = new EventEmitter();

  isAuthenticated: boolean = false;

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  @ViewChild("title") title: ElementRef;
  @ViewChild("createUnit") createUnit: ElementRef;
  @ViewChild("createPrice") createPrice: ElementRef;

  strSearch: string = "";
  menuItems: NbMenuItem[] = [
    { title: "Sửa", icon: "edit-2-outline", data: null },
    { title: "Xóa", icon: "trash-2-outline", data: null },
    {
      title: "Chi tiết",
      icon: "external-link-outline",
      data: null,
    },
  ];

  isInit: boolean = true;
  isProduct = false;
  isCreate: boolean = false;
  filterCatalog = false;
  selectedCatalog = "";
  page: number = 1;
  display?: Product[] = [];
  displayInit?: Product[] = [];
  products: Product[] = [];

  catalogs?: Catalog[] = [];
  mode?: string = "units"; //catalog.mode
  units?: Catalog[] = [];
  groups?: Catalog[] = [];
  categories?: Catalog[] = [];
  suppliers?: Catalog[] = [];
  producers?: Catalog[] = [];
  origins?: Catalog[] = [];
  sizes?: Catalog[] = [];
  colors?: Catalog[] = [];
  groupFins?: Catalog[] = [];

  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";
  roundToTwoDecimals = environment.formatCurrency.includes("###.##");

  isMobile: boolean = false;
  quantity: string = "";

  constructor(
    private userService: UserService,
    private catalogService: CatalogService,
    private productService: ProductService,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService,
    private router: Router,
    private hotkeys: Hotkeys,
  ) {
    hotkeys
      .addShortcut({ keys: "control.x" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log("hotkeys/control.x");
        this.title.nativeElement.focus();
        this.isCreate = false;
        this.clearSearch();
      });

    hotkeys
      .addShortcut({ keys: "control.enter" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log("hotkeys/control.enter");
        this.isCreate = true;
        if (this.strSearch.length > 0) {
          this.elemFocus("createUnit");
        } else {
          this.elemFocus("title");
        }
      });
  }

  ngOnInit(): void {
    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        this.getCatalogs();
        this.displayInit = [];
        _.forEach(this.receipt.receiptDetails, (item) => {
          let prod = _.find(this.productService.products, {
            id: item.productId,
          });
          if (prod) {
            prod.receiptDetail = item;
            this.displayInit.push(prod);
          }
        });

        this.display = [...this.displayInit];
      });

    const titleValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const priceValidators = [Validators.pattern(DOUBLE_PATTERN)];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      price: ["", priceValidators],
      costPrice: ["", priceValidators],
      quantity: ["", priceValidators],
      unit: [],
    });

    this.nbMenuService
      .onItemClick()
      .pipe(
        map(({ item }) => item),
        takeUntil(this.destroy$),
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.onEdit(item.data);
            break;
          case "Xóa":
            this.delete(item.data);
            break;
          case "Chi tiết":
            this.detail(item.data);
            break;
          default:
            break;
        }
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.title.nativeElement.focus();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCatalogs(): void {
    this.catalogService
      .getCatalogs(this.shopId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          })),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (data) => {
          this.units = [];
          this.groups = [];
          this.categories = [];
          this.suppliers = [];
          this.producers = [];
          this.origins = [];
          this.sizes = [];
          this.colors = [];
          _.forEach(data, (item) => {
            switch (item.mode) {
              case "units":
                this.units.push(item);
                break;
              case "groups":
                this.groups.push(item);
                break;
              case "categories":
                this.categories.push(item);
                break;
              case "producers":
                this.producers.push(item);
                break;
              case "origins":
                this.origins.push(item);
                break;
              case "sizes":
                this.sizes.push(item);
                break;
              case "colors":
                this.colors.push(item);
                break;
              default:
                break;
            }
          });
        },
        (error) => {
          console.error("getCatalogs:", error);
        },
      );
  }

  loadProducts() {
    this.productService.initIndexedDbProducts(this.shopId, this.isInit);
    this.isInit = false;
  }

  selected(item: Product): void {
    item.price = item.price ? item.price : 0;
    item.wsPrice = item.wsPrice ? item.wsPrice : 0;
    item.costPrice = item.costPrice ? item.costPrice : 0;
    item.quantity = isNaN(parseFloat(this.quantity))
      ? 1
      : parseFloat(this.quantity);

    this.onSelectedProduct.emit(item);

    this.quantity = "";
    this.title.nativeElement.focus();
  }

  productQuantityChanged(item) {
    console.log(
      "🚀 ~ ViewReceiptProductsComponent ~ productQuantityChanged ~ item:",
      item,
    );

    if (item.receiptDetail) {
      var index = _.findIndex(this.receipt.receiptDetails, {
        productId: item.id,
      });
      console.log(
        "🚀 ~ ViewReceiptProductsComponent ~ productQuantityChanged ~ index:",
        index,
      );

      if (index >= 0) {
        let rcpDetail = this.receipt.receiptDetails[index];
        rcpDetail.quantity = item.receiptDetail.quantity;
        rcpDetail.price = item.receiptDetail.price;

        rcpDetail.netAmount = rcpDetail.quantity * rcpDetail.price;
        if (rcpDetail.discountPercent != 0) {
          let discountAmount =
            (rcpDetail.netAmount * rcpDetail.discountPercent) / 100;
          discountAmount = ((discountAmount + Number.EPSILON) * 100) / 100;
          rcpDetail.discountAmount = this.roundToTwoDecimals
            ? parseFloat(discountAmount.toFixed(2))
            : Math.round(discountAmount);
        }
        rcpDetail.amount = rcpDetail.netAmount - rcpDetail.discountAmount;
        rcpDetail.costAmount = rcpDetail.costQuantity * rcpDetail.costPrice;
        rcpDetail.profit = rcpDetail.amount - rcpDetail.costAmount;
        rcpDetail.timestamp = new Date().getTime();

        item.receiptDetail = rcpDetail;

        if (rcpDetail.quantity === 0) {
          this.receipt.receiptDetails.splice(index, 1);
        }
      } else if (item.receiptDetail.quantity != 0) {
        let prod = new ReceiptDetail();
        prod.productId = item.id;
        prod.productCode = item.barcode
          ? item.barcode
          : item.code
            ? item.code
            : "";
        prod.productName = item.title;
        prod.productDescription = item.description;
        prod.productUnitName = item.unitName;
        //Advance information
        prod.productUnitId = item.unitId ? item.unitId : "";
        prod.productGroupId = item.groupId ? item.groupId : "";
        prod.productGroupName = item.groupName ? item.groupName : "";
        prod.productCategoryId = item.categoryId ? item.categoryId : "";
        prod.productCategoryName = item.categoryName ? item.categoryName : "";
        prod.productSupplierId = item.supplierId ? item.supplierId : "";
        prod.productSupplierName = item.supplierName ? item.supplierName : "";
        prod.productProducerId = item.producerId ? item.producerId : "";
        prod.productProducerName = item.producerName ? item.producerName : "";
        prod.productOriginId = item.originId ? item.originId : "";
        prod.productOriginName = item.originName ? item.originName : "";
        prod.productSizeId = item.sizeId ? item.sizeId : "";
        prod.productSizeName = item.sizeName ? item.sizeName : "";
        prod.productColorId = item.colorId ? item.colorId : "";
        prod.productColorName = item.colorName ? item.colorName : "";

        prod.productCostPrice = item.costPrice;
        prod.price = item.price ? item.price : 0;
        prod.costPrice = item.costPrice ? item.costPrice : 0;

        prod.quantity = item.receiptDetail.quantity;
        prod.costQuantity = item.receiptDetail.quantity;

        prod.netAmount = prod.quantity * prod.price;

        prod.discountPercent = 0;
        if (prod.discountPercent != 0) {
          let discountAmount = (prod.netAmount * prod.discountPercent) / 100;
          discountAmount = ((discountAmount + Number.EPSILON) * 100) / 100;

          prod.discountAmount = this.roundToTwoDecimals
            ? parseFloat(discountAmount.toFixed(2))
            : Math.round(discountAmount);
        } else {
          prod.discountPercent = 0;
          prod.discountAmount = 0;
        }

        prod.amount = this.roundToTwoDecimals
          ? parseFloat((prod.netAmount - prod.discountAmount).toFixed(2))
          : Math.round(prod.netAmount - prod.discountAmount);

        prod.costAmount = prod.costQuantity * prod.costPrice;
        prod.profit = prod.amount - prod.costAmount;
        prod.comment = "";
        prod.timestamp = new Date().getTime();

        //customer
        if (this.receipt.customerId) {
          prod.customerId = this.receipt.customerId;
          prod.customerName = this.receipt.customerName;
        }

        item.receiptDetail = prod;
        this.receipt.receiptDetails.push(prod);
      }

      this.receipt.isDetailChanged = true;
      this.summaryReceipt();
    }
  }

  productQuantityIncrement(item, value) {
    item.receiptDetail.quantity = item.receiptDetail.quantity
      ? item.receiptDetail.quantity
      : 0;
    item.receiptDetail.quantity += value;

    item.receiptDetail.price = item.receiptDetail.price
      ? item.receiptDetail.price
      : item.price
        ? item.price
        : 0;

    // item.receiptDetail.amount =
    //   item.receiptDetail.price * item.receiptDetail.quantity;

    console.log("productQuantityIncrement:", item);

    this.productQuantityChanged(item);
  }

  summaryReceipt() {
    this.onSummaryReceipt.emit();
  }

  viewStock(item): void {
    console.log("selectedProduct/selected:", item);

    this.dialogService
      .open(DialogProductInventoriesComponent, {
        context: {
          shopId: this.shopId,
          product: item,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value.hadChange) {
          this.onSearch();
        }
      });
  }

  create() {
    this.strSearch = this.strSearch.trim();
    if (this.strSearch != "") {
      console.log(this.diaForm.value);

      let prod = new Product();
      prod.expDate = new Date();
      prod.shopId = this.shopId;
      prod.title = this.diaForm.value.title;
      prod.unitName = this.diaForm.value.unit ? this.diaForm.value.unit : "Cái";
      prod.price = parseFloat(this.diaForm.value.price.toString());
      prod.costPrice = parseFloat(this.diaForm.value.costPrice.toString());

      this.loading = true;
      this.submitted = true;

      this.productService
        .create(prod)
        .then((data) => {
          prod.id = data.id;
          prod.quantity = parseFloat(this.diaForm.value.quantity.toString());

          this.diaForm.patchValue({
            title: "",
            price: "",
            costPrice: "",
            unit: "",
            quantity: "",
          });

          this.strSearch = "";
          this.title.nativeElement.focus();
          this.display = _.take(this.productService.products, 10);

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    } else {
      this.elemFocus("title");
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.productService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.display = [...this.productService.products];
              this.loading = false;
              this.submitted = false;

              //sync data to offline DB
              item.isDeleted = true;
              this.productService.sync(item);
              this.onSearch();
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  detail(item) {
    let lecBk = new Product();
    lecBk = _.clone(item);
    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Cập nhật sản phẩm",
          user: this.user,
          mode: "edit",
          product: lecBk,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        console.log("detail/subscribe", value);
        if (value) {
          item = value;
          this.productService.sync(item);
          this.onSearch();
        }
      });
  }

  eTitle = "";
  eUnit = "";
  ePrice = 0;
  eCostPrice = 0;
  isEditing = false;
  onEdit(item: Product): void {
    item.editing = true;
    this.eTitle = item.title;
    this.eUnit = item.unitName;
    this.ePrice = item.price;
    this.eCostPrice = item.costPrice;
    this.isEditing = true;
  }
  cancelEdit(item: Product) {
    item.editing = false;
    this.isEditing = false;
  }
  confirmEdit(item: Product) {
    item.loading = true;
    item.title = this.eTitle;
    item.unitName = this.eUnit ? this.eUnit : "";
    item.price = this.ePrice ? parseFloat(this.ePrice.toString()) : 0;
    item.costPrice = this.eCostPrice
      ? parseFloat(this.eCostPrice.toString())
      : 0;

    this.productService
      .updatePrice(
        this.shopId,
        item.id,
        item.title,
        item.unitName,
        item.price,
        item.costPrice,
      )
      .then((data) => {
        console.log(
          "🚀 ~ ViewReceiptProductsComponent ~ confirmEdit ~ data:",
          data,
        );
        this.eTitle = "";
        this.eUnit = "";
        this.ePrice = 0;
        this.eCostPrice = 0;

        item.editing = false;
        item.loading = false;
        this.isEditing = false;

        //sync data to offline DB
        this.productService.sync(item);
      })
      .catch((err) => {
        console.log(
          "🚀 ~ ViewReceiptProductsComponent ~ confirmEdit ~ err:",
          err,
        );
        item.loading = false;
      });
  }

  onSearch(): void {
    this.page = 1;
    const strFilter = this.strSearch.toLowerCase();
    console.log("onSearch", strFilter);

    this.loading = true;
    this.display = [];
    this.displayInit = [];
    if (!strFilter || strFilter === "") {
      this.loading = false;

      _.forEach(this.productService.products, (item) => {
        let receiptD = _.find(this.receipt.receiptDetails, {
          productId: item.id,
        });
        item.receiptDetail = receiptD ? receiptD : new ReceiptDetail();
        if (receiptD) {
          this.displayInit.push(item);
        } else {
          this.display.push(item);
        }
      });

      this.display = [...this.displayInit, ...this.display];
    } else {
      this.productService.searchProducts(strFilter).then(
        (data) => {
          // this.display = data;
          console.log(
            "🚀 ~ ViewReceiptProductsComponent ~ onSearch ~ data:",
            data,
          );

          _.forEach(data, (item) => {
            let receiptD = _.find(this.receipt.receiptDetails, {
              productId: item.id,
            });
            item.receiptDetail = receiptD ? receiptD : new ReceiptDetail();
            this.display.push(item);
          });

          this.loading = false;
        },
        (err) => {
          this.display = [];
          this.loading = false;
        },
      );
    }
  }

  clearSearch() {
    this.strSearch = "";

    this.display = [...this.displayInit];
    this.onSearch();
  }

  addProduct() {
    this.isCreate = !this.isCreate;
  }

  loadButtonAction(item: Product) {
    console.log("loadButtonAction", item);

    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: item },
      {
        title: "Chi tiết",
        icon: "external-link-outline",
        data: item,
      },
    ];
  }

  elemFocus(ctr: string) {
    switch (ctr) {
      case "createUnit":
        this.createUnit
          ? this.createUnit.nativeElement.focus()
          : (this.isCreate = true);
        break;
      case "createPrice":
        this.createPrice
          ? this.createPrice.nativeElement.focus()
          : (this.isCreate = true);
        break;
      case "title":
        this.title.nativeElement.focus();
        break;
      default:
        this.title.nativeElement.focus();
        break;
    }
  }
}
